<template>
  <div class="configurator_controls">
    <div class="configurator_controls_wrapper">
      <div class="configurator-tooltip">
        <div class="configurator-tooltip-wrapper">
          <div class="tooltip-button" @click="switchMenu()" :class="{'tooltip-button_back': this.menuStep == 2, 'tooltip-button_close': this.menuStep == 1}">
            <div class="icon">
              <transition name="back_arrow">
                <svg v-if="menuStep == 2" class="back" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                  <g fill="none" fill-rule="evenodd">
                    <path d="M.5.5l11 11" />
                    <path d="M11.5.5l-11 11" />
                  </g>
                </svg>
              </transition>

              <svg class="add-close" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fill-rule="evenodd">
                  <path d="M.5.5l11 11" />
                  <path d="M11.5.5l-11 11" />
                </g>
              </svg>

            </div>

          </div>
          <div class="menu-categories" :class="{'visible': this.menuStep ==1}" :data-count="menuCategories.length">
            <div class="first_line menu-categories-line">
              <div v-if="indexCategory < 2" v-for="(categorie, indexCategory) in menuCategories" @click="openMenuFurnitures(indexCategory)" class="menu-categories-elem">
                <span v-if="language == 'en'">{{categorie.name}}</span>
                <span v-else="language == 'de'">{{categorie.name_de}}</span>
              </div>
            </div>
            <div class="second_line menu-categories-line">
              <div v-if="indexCategory == 2" v-for="(categorie, indexCategory) in menuCategories" @click="openMenuFurnitures(indexCategory)" class="menu-categories-elem">
                <span v-if="language == 'en'">{{categorie.name}}</span>
                <span v-else="language == 'de'">{{categorie.name_de}}</span>
              </div>
            </div>
            <div class="third_line menu-categories-line">
              <div v-if="indexCategory > 2" v-for="(categorie, indexCategory) in menuCategories" @click="openMenuFurnitures(indexCategory)" class="menu-categories-elem">
                <span v-if="language == 'en'">{{categorie.name}}</span>
                <span v-else="language == 'de'">{{categorie.name_de}}</span>
              </div>
            </div>
          </div>
          <div class="menu-furnitures" :class="{ 'item-selected': currentFurniture.name !=='','visible': this.menuStep ==2}">
            <div
            v-for="(furniture, indexFurnitures) in menuFurnitures"
            :key="indexFurnitures"
            class="draggable ui-widget-draggable menu-furnitures-elem"
            :data-furniture-name="furniture.name"
            :data-furniture-category = "furniture.category"
            :data-furniture-filePath="furniture.filePath"
            :class="{'selected': currentFurniture == furniture}"
            :style="">
            <div
            class="furniture-background">
            <img :src="'/assets/thumbnail/'+furniture.filePath[0]" alt="">
          </div>
        </div>
      </div>

      <div v-if="currentScenario" class="tooltip-info">

        <transition name="tooltip_change" @enter="tooltipEnter" @afterEnter="tooltipAfterEnter">
          <div v-if="!toolTipChange" class="tooltip-text" key="has-text">
            <span v-if="currentFurniture.name !== '' && language == 'en'"><strong>{{ currentFurniture.name }}</strong></span>
            <span v-else-if="currentFurniture.name !== '' && language == 'de'"><strong> {{ currentFurniture.name_de }}</strong></span>
            <span v-else-if="menuStep == 0" @click="switchMenu()" class="tooltipText-start"><strong>{{ currentScenario.tooltip[language] }}</strong>
            </span>
            <span v-else-if="menuStep == 1"> <strong> {{ tooltipText[0][language] }}</strong> </span>
            <span v-else-if="menuStep == 2"> <strong>{{ tooltipText[1][language] }}</strong>  </span>
          </div>
          <div v-else class="tooltip-loading" key="loading">
            <span>

              <svg width="30" height="8" viewBox="0 0 30 8" xmlns="http://www.w3.org/2000/svg">
                <g fill="white" fill-rule="evenodd">
                  <circle  cx="3.947" cy="3.947" r="3.947"/>
                  <circle  cx="15" cy="3.947" r="3.947"/>
                  <circle  cx="26.053" cy="3.947" r="3.947"/>
                </g>
              </svg>


            </span>
          </div>

        </transition>


      </div>

    </div>
  </div>
  <div class="controls-furniture" :class="{'visible':controlsFurnitureVisible}">
    <div v-if="controlsFurnitureCanRotate" class="rotate" @click="rotateFurniture" >
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
        <defs>
          <clipPath id="clip-path">
            <path id="Tracé_63" data-name="Tracé 63" d="M0,0H20V20H0Z" fill="none" clip-rule="evenodd"/>
          </clipPath>
        </defs>
        <g id="Groupe_87" data-name="Groupe 87" transform="translate(0 0)">
          <g id="Groupe_86" data-name="Groupe 86">
            <g id="Groupe_83" data-name="Groupe 83" clip-path="url(#clip-path)">
              <g id="Groupe_82" data-name="Groupe 82">
                <path id="Tracé_62" data-name="Tracé 62" d="M0,0H20V20H0Z" fill="none" stroke="#333" stroke-width="0"/>
              </g>
            </g>
            <g id="Groupe_85" data-name="Groupe 85" clip-path="url(#clip-path)">
              <g id="Groupe_84" data-name="Groupe 84" transform="translate(3.333 0.833)">
                <path id="Tracé_64" data-name="Tracé 64" d="M13.625,4.792,9.833,1V3.558a6.66,6.66,0,0,0,0,13.217V15.092a4.994,4.994,0,0,1,0-9.85V8.5Zm3.65,4.542a6.588,6.588,0,0,0-1.35-3.242L14.742,7.275a4.838,4.838,0,0,1,.85,2.058h1.683ZM11.5,15.083v1.683a6.6,6.6,0,0,0,3.25-1.342l-1.2-1.2a4.821,4.821,0,0,1-2.05.858Zm3.242-2.017,1.183,1.175A6.588,6.588,0,0,0,17.275,11H15.592A4.914,4.914,0,0,1,14.742,13.067Z" transform="translate(-4 -1)" fill="#333"/>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
    <div class="delete" @click="deleteFurniture">
      <svg xmlns="http://www.w3.org/2000/svg" class="close" width="24" height="24" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    </div>
  </div>
  <div :class="{'visible': currentFurniture.active_zone.includes(zone.index) && availableZones.includes(zone.index) }"  v-for="(zone,indexZone) in droppableZone" class="ui-widget-droppable droppable-zone" :data-zone="zone.index" :style="'top:'+zone.position[1]+'%; left:'+zone.position[0]+'%;'">
  </div>
</div>
</div>
</template>

<script>

import scenarios from '../../assets/furnituresScenarios.json';

import { mapGetters } from 'vuex'
import {masterBus} from '@/main.js';

export default {
  name: 'ConfiguratorControls',
  data(){
    return {
      buttonTL:null,
      isElementsMenuOpen:false,
      menuCategories:[],
      menuFurnitures:[],
      currentCategoryElements:null,
      scenarios: scenarios,
      currentZone:null,
      tooltipText:"",
      menuStep:0,
      currentFurniture:{"name":"","name_de":"","active_zone":""},
      furnitureCategoryIndex:0,
      elementDragged:false,
      controlsFurnitureVisible:false,
      controlsFurnitureCanRotate: true,
      currentZone:null,
      toolTipChange:false,
      toolTipTimeout:null,
      toolTipLoadingWidth: null,
      activeZone:[],
      currentConfiguration:[
        {"zone":0},
        {"zone":1},
        {"zone":2},
        {"zone":3},
        {"zone":4},
        {"zone":5},
        {"zone":6}
      ],
      tooltipText:[
        {
          "en":"Choose Category",
          "de":"Kategorie wählen"
        },
        {
          "en":"Drag item on Pod",
          "de":"Gegenstand auf Pod ziehen"
        }
      ],
      availableZones:[0,1,2,3,4,5,6],
      droppableZone:[
        {
          index:0,
          position:[31,65]
        },
        {
          index:1,
          position:[42,57]
        },
        {
          index:2,
          position:[54,49]
        },
        {
          index:3,
          position:[23,57]
        },
        {
          index:4,
          position:[33,49]
        },
        {
          index:5,
          position:[44,41]
        },
        {
          index:6,
          position:[58,36]
        }
      ],
      lastTooltipText:""
    }
  },
  computed: {
    ...mapGetters(['currentScenario','language','podSize','infoOpened'])
  },
  watch:{
    podSize:function(val){
      this.changeAvailableZones();
    },
    language:function(val){
      if(val == 'de'){
        if(this.menuStep == 1){
          $('.loaded strong').text(this.tooltipText[0].de);
        }
        else if(this.menuStep == 2){
          $('.loaded strong').text(this.tooltipText[1].de);
        }
      }
      else{
        if(this.menuStep == 1){
          $('.loaded strong').text(this.tooltipText[0].en);
        }
        else if(this.menuStep == 2){
          $('.loaded strong').text(this.tooltipText[1].en);
        }
      }
      new TweenMax($('.loaded'),.4, {ease:  Power2.easeOut,width:'auto'})

    },
    currentScenario: function(val) {
      //this.toolTipChanged()
    },
    currentFurniture:function(val){
      this.replaceTooltipText(val)
    }

  },
  mounted(){
    masterBus.$on('displayDropZones', this.displayDropZones);
    masterBus.$on("displayControlsFurniture",this.displayControlsFurniture);
    masterBus.$on("hideControlsFurniture",this.hideControlsFurniture);
    masterBus.$on("setDropZonePosition",this.setDropZonePosition);
    window.addEventListener('resize', this.hideControlsFurniture);
  },
  beforeDestroy(){
    masterBus.$off('displayDropZones', this.displayDropZones);
    masterBus.$off("displayControlsFurniture",this.displayControlsFurniture);
    masterBus.$off("hideControlsFurniture",this.hideControlsFurniture);
    masterBus.$off("setDropZonePosition",this.setDropZonePosition);
  },
  methods:{
    setDropZonePosition(params){
      let positionX = params.worldTransform.tx - params.pivotX/2;
      let positionY = params.worldTransform.ty - params.pivotY/2;
      $("[data-zone*="+params.index+"]").attr("style","top:"+positionY+"px; left:"+positionX+"px;");
    },
    changeAvailableZones(){
      if(this.podSize == "S"){
        let shift = 7;
        for(let i=0; i <= 6; i++){
          $("[data-zone*="+i+"]").attr("style","top:"+(this.droppableZone.find((o => o.index == $('[data-zone*='+i+']').attr('data-zone'))).position[1])+"%;left:"+(this.droppableZone.find((o => o.index == $('[data-zone*='+i+']').attr('data-zone'))).position[0]+shift)+"%;");
        }
        $("[data-zone*=6]").attr("style","top:44%;left:55%;");

        this.availableZones = [0,1,3,4,6];
      }
      else {
        for(let i=0; i <= 6; i++){
          $("[data-zone*="+i+"]").attr("style","top:"+(this.droppableZone.find((o => o.index == $('[data-zone*='+i+']').attr('data-zone'))).position[1])+"%;left:"+(this.droppableZone.find((o => o.index == $('[data-zone*='+i+']').attr('data-zone'))).position[0])+"%;");
        }
        this.availableZones = [0,1,2,3,4,5,6];
      }
      let listFurniture = this.menuFurnitures;
      let pendingList =[];
      for(let i in listFurniture){
        if(this.podSize =="S"){
          if(listFurniture[i].category !== 'F'){
            pendingList.push(listFurniture[i]);
          }
          this.menuFurnitures = pendingList;
        }
        else{
          pendingList.push(listFurniture[i]);
          this.menuFurnitures = pendingList;
        }
      }
    },
    styleSprite(path){
      return "url("+path+");";
    },
    emitEvent(eventName,eventOptions){
      masterBus.$emit(eventName,eventOptions);
    },
    switchMenu(){
      this.hideControlsFurniture();
      if(this.infoOpened){
        this.$store.dispatch('setInfoOpened',false);
      }
      this.toolTipChanged();

      switch (this.menuStep) {
        case 0:
        this.openMenuCategories();
        this.menuStep = 1;
        break;
        case 1:
        this.closeMenuCategories();
        this.menuStep = 0;
        break;
        case 2:
        this.closeMenuFurnitures();
        this.openMenuCategories();
        this.menuStep = 1;
        break;
        default:
      }
    },
    deleteFurniture(){
      if(this.currentConfiguration.find((o => o.furnitureCategory == "F"))){
        this.emitEvent('deleteFurniture',0);
        this.currentConfiguration =[
          {"zone":0},
          {"zone":1},
          {"zone":2},
          {"zone":3},
          {"zone":4},
          {"zone":5},
          {"zone":6}
        ]
      }
      else{
        this.emitEvent('deleteFurniture',this.currentZone);
        var currentConfigurationZone = this.currentConfiguration.find((o => o.zone == this.currentZone));
        currentConfigurationZone.furnitureViews = [];
        currentConfigurationZone.furnitureName = "";
        currentConfigurationZone.furnitureCurrentViewIndex = null;
      }
      this.hideControlsFurniture();
    },
    rotateFurniture(){
      var currentConfigurationZone = this.currentConfiguration.find((o => o.zone == this.currentZone));
      if(currentConfigurationZone.furnitureCurrentViewIndex + 1 < currentConfigurationZone.furnitureViews.length){
        currentConfigurationZone.furnitureCurrentViewIndex += 1;
      }
      else{
        currentConfigurationZone.furnitureCurrentViewIndex = 0;
      }
      let newView =currentConfigurationZone.furnitureViews[currentConfigurationZone.furnitureCurrentViewIndex];
      masterBus.$emit("placeArrangement",{'zone':this.currentZone,'arrangement':newView});
    },
    hideControlsFurniture(){
      this.currentZone =  "";
      this.controlsFurnitureVisible = false;
    },
    snapToZone(index,params){
      this.emitEvent('hideAvailableDropZones',this.currentFurniture.active_zone);
      this.currentZone = index;
      if(this.currentFurniture.category == "F" || this.currentConfiguration.find((o => o.furnitureCategory == "F"))){
        if(this.currentConfiguration.find((o => o.furnitureCategory == "F"))){
          masterBus.$emit("resetSkateboard");
        }
        this.currentConfiguration =[
          {"zone":0},
          {"zone":1},
          {"zone":2},
          {"zone":3},
          {"zone":4},
          {"zone":5},
          {"zone":6}
        ]
      }
      if(this.currentZone == 3 && this.currentFurniture.category=="FR"){
        masterBus.$emit("placeArrangement",{'zone':this.currentZone,'arrangement':this.currentFurniture.filePath[1],'category':'FL'});
      }
      else{
        if(this.currentFurniture.filePath[0]){
          masterBus.$emit("placeArrangement",{'zone':this.currentZone,'arrangement':this.currentFurniture.filePath[0],'category':this.currentFurniture.category});
        }
      }

      var currentConfigurationZone;
      if(this.currentFurniture.category == "F"){
        currentConfigurationZone = this.currentConfiguration.find((o => o.zone == 0));
      }
      else{
        currentConfigurationZone = this.currentConfiguration.find((o => o.zone == this.currentZone));
      }
      currentConfigurationZone.furnitureViews = this.currentFurniture.filePath;
      currentConfigurationZone.furnitureName = this.currentFurniture.name;
      currentConfigurationZone.furnitureCurrentViewIndex = 0;
      currentConfigurationZone.furnitureCategory = this.currentFurniture.category;
      this.resetCurrentFurniture();
      this.displayControlsFurniture(params);

    },
    openMenuCategories(){

      this.menuCategories = this.currentScenario.furnitures_categories;
    },
    closeMenuCategories(){
    },
    openMenuFurnitures(index){
      this.toolTipChanged()
      this.menuStep = 2;
      this.furnitureCategoryIndex = index;
      this.closeMenuCategories();
      let listFurniture = this.currentScenario.furnitures_categories[this.furnitureCategoryIndex].furnitures;
      let pendingList =[];
      for(let i in listFurniture){
        if(this.podSize =="S"){
          if(listFurniture[i].category !== 'F'){
            pendingList.push(listFurniture[i]);
          }
          this.menuFurnitures = pendingList;
        }
        else{
          pendingList.push(listFurniture[i]);
          this.menuFurnitures = pendingList;
        }
      }
      setTimeout(()=>{
        this.initDraggable();
      },500);
    },
    resetCurrentFurniture(){
      this.currentFurniture = {"name":"","active_zone":""};
    },
    closeMenuFurnitures(){
      this.furnitureCategoryIndex = 0;
      $('.tooltip-button').removeClass("tooltip-button_back");
      this.resetCurrentFurniture();
    },
    changeFurniture(furnitureName, furnitureFile){
      let furniture = this.currentScenario.furnitures_categories[this.furnitureCategoryIndex].furnitures.find((object)=>{if(object.name == furnitureName)return object});
      if(furniture.name == this.currentFurniture.name){
        this.resetCurrentFurniture();
      }
      else{
        this.currentFurniture = furniture;
        this.emitEvent('showAvailableDropZones',this.currentFurniture.active_zone);
      }
    },
    displayDropZones(){
    },
    hideDropZones(){
      $('.configurator_controls').removeClass("ready");
    },
    displayControlsFurniture(params){
      this.controlsFurnitureCanRotate = true;
      if(this.controlsFurnitureVisible){
        this.controlsFurnitureVisible = false;
        if(this.currentZone !== params.furniture.target.zone){
          this.currentZone =  params.furniture.target.zone;
          let targetFurnitureCategory = this.currentConfiguration.find((o => o.zone == this.currentZone)).furnitureCategory;
          if(targetFurnitureCategory == "FR" || targetFurnitureCategory == "FL" || targetFurnitureCategory == "F" || targetFurnitureCategory == "BL") this.controlsFurnitureCanRotate = false;
          else this.controlsFurnitureCanRotate = true;
          this.controlsFurnitureVisible = true;
          $('.controls-furniture').attr("style","top:"+ params.y+"px; left:"+ params.x+"px;")
        }
      }
      else{
        this.currentZone =  params.furniture.target.zone;
        this.controlsFurnitureVisible = true;
        let targetFurnitureCategory;
        if(this.currentConfiguration.find((o => o.zone == 0)).furnitureCategory == 'F'){
          targetFurnitureCategory = this.currentConfiguration.find((o => o.zone == 0)).furnitureCategory;
        }
        else{
          targetFurnitureCategory = this.currentConfiguration.find((o => o.zone == this.currentZone)).furnitureCategory;
        }
        if(targetFurnitureCategory == "FR" || targetFurnitureCategory == "FL" || targetFurnitureCategory == "F" || targetFurnitureCategory == "BL") this.controlsFurnitureCanRotate = false;
        else this.controlsFurnitureCanRotate = true;
        $('.controls-furniture').attr("style","top:"+ params.y+"px; left:"+ params.x+"px;")
      }
    },
    initDraggable(){
      $('.draggable').draggable({
        revert: 'invalid',
        cancel:'.no-drag',
        helper: "clone",
        cursor: "crosshair",
        refreshPositions: true, //added line,
        start:(event,ui)=>{
          this.changeFurniture(ui.helper.attr("data-furniture-name"),ui.helper.attr("data-furniture-filePath"));
          this.elementDragged = true;
          ui.helper.addClass("selected");
          this.hideControlsFurniture();
        },
        stop:(event,ui)=>{
          this.emitEvent('hideAvailableDropZones',this.currentFurniture.active_zone);
          this.resetCurrentFurniture();
        }
      });
      $(".droppable-zone").droppable({
        accept: '.draggable',
        activeClass: 'ui-state-active',
        hoverClass: 'ui-state-hover',
        over: ( event, ui )=> {
          let zones = [];
          if(ui.draggable.attr("data-furniture-category") == "F"){
            zones = [0,1,2,3,4,5,6];
          }else{
            let index = $(event.target).attr("data-zone");
            zones.push(index);
          }
          this.emitEvent('displayDropZone',zones);
        },
        out: ( event, ui )=> {
          let zones = [];
          if(ui.draggable.attr("data-furniture-category") == "F"){
            zones = [0,1,2,3,4,5,6];
          }else{
            let index = $(event.target).attr("data-zone");
            zones.push(index);
          }
          this.emitEvent('hideDropZone',zones);
          this.emitEvent('showAvailableDropZones',this.currentFurniture.active_zone);
        },
        drop: (event, ui)=> {
          let index = $(event.target).attr("data-zone");
          let params;
          if(this.currentFurniture.category == "F"){
            params = {
              "x":$("[data-zone*=0]").offset().left,
              "y":$("[data-zone*=0]").offset().top,
              "furniture":{"target":{"zone":index}}
            }
          }
          else{
            params = {
              "x":$(event.target).offset().left,
              "y":$(event.target).offset().top,
              "furniture":{"target":{"zone":index}}
            }
          }
          this.snapToZone(index,params);
        }
      });
    },
    resetControls(){
      $("#draggable").removeAttr('style');
      $("#draggable").removeClass('ui-state-dropped');
      $('#draggable').draggable('destroy');
      this.closeMenuCategories();
      this.closeMenuFurnitures();
      this.initControls();
    },
    toolTipReset() {
      this.toolTipChange = false
    },
    replaceTooltipText(val){
      if(val.name !== ""){
        this.lastTooltipText = $('.loaded strong').text();
        if(this.language == 'en'){
          $('.loaded strong').text(val.name);
        }
        else {
          $('.loaded strong').text(val.name_de);
        }
        new TweenMax($('.loaded'),.4, {ease:  Power2.easeOut,width:'auto'})
      }
      else{
        $('.loaded strong').text(this.lastTooltipText);
      }
    },
    toolTipChanged() {
      this.toolTipChange = true;
      clearTimeout(this.toolTipTimeout);
      this.toolTipTimeout = setTimeout(this.toolTipReset, 750);
    },
    tooltipEnter(el) {

      let span = el.querySelector('span');
      if(el.classList.contains('tooltip-loading')) {
        this.toolTipLoadingWidth = el.offsetWidth;
      } else {
        let textContainer = document.createElement('strong');
        textContainer.innerText = span.innerText;
        textContainer.style.opacity = 0;

        span.innerHTML = '';
        span.appendChild(textContainer);

        let toWidth = el.offsetWidth;
        span.dataset.width = toWidth + 'px';
        span.style.width = this.toolTipLoadingWidth + 'px';
        span.style.color = 'transparent';
      }

    },
    tooltipAfterEnter(el) {
      let span = el.querySelector('span');

      let textContainer = span.querySelector('strong');
      if(textContainer)
      textContainer.style.opacity = 1;

      setTimeout(()=>{
        if(el.classList.contains('tooltip-text')) {
          span.style.width = span.dataset.width
          span.style.color = '';
          span.classList.add('loaded')
        }
      }, 50)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >

$button_size : 60px;
$info_height : 70px;
$tooltip_height:280px;
$tooltip_width:640px;
$background_color_tooltip: #333;
$background_color_tooltip_menu: #ffffff;
$padding:15px;
$opacity_furniture_not_selected :.4;

@mixin button-style{
  height: $button_size;
  display: flex;
  align-items: center;
  span{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
@mixin button-style-dark{
  @include button-style;
  span{
    height: 100%;
    background: $background_color_tooltip;
    color:rgb(205, 205, 205);
    border-radius: 30px;
    -webkit-border-radius: 30px;
    -moz-border-radius:30;
    box-shadow: 0 10px 10px -10px rgba(0,0,0,.1);
    -webkit-box-shadow: 0 10px 10px -10px rgba(0,0,0,.1);
     -moz-box-shadow:0 10px 10px -10px rgba(0,0,0,.1);
    padding: 1rem 2rem;
  }
}
@mixin button-style-light{
  @include button-style;
  span{
    background: $background_color_tooltip_menu;
    border-radius: 30px;
    -webkit-border-radius: 30px;
    -moz-border-radius:30px;
    background: #fff;
    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.16);
    -webkit-box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.16);
    -moz-box-shadow:0px 3px 20px rgba(0, 0, 0, 0.16);
    padding: 1rem 2rem;
  }
}

@mixin cubic-transition($duration) {
  -webkit-transition: all $duration cubic-bezier(0, 0, 0.2, 1);
  -moz-transition: all $duration cubic-bezier(0, 0, 0.2, 1);
  -ms-transition: all $duration cubic-bezier(0, 0, 0.2, 1);
  -o-transition:all $duration cubic-bezier(0, 0, 0.2, 1);
  transition: all $duration cubic-bezier(0, 0, 0.2, 1);
}

$cubic-ease-in-out: cubic-bezier(.49,.4,.2,1);
$cubic-ease-out: cubic-bezier(0,.54,.02,1);
$animation-delay: 75ms;

.configurator-tooltip{
  width:$tooltip_width;
  height: $tooltip_height;
  position: absolute;
  bottom: 5%;
  z-index: 200;
  right: 0;
  .configurator-tooltip-wrapper{
    width: 100%;
    height: 100%;
    position: relative;
    .tooltip-button{
      @include cubic-transition(.6s);
      z-index: 10;
      cursor: pointer;
      width: $button_size;
      height:$button_size;
      background: $background_color_tooltip_menu;
      position: absolute;
      top:$tooltip_height/2 - $button_size/2;
      left:$tooltip_width/2 - $button_size/2;
      border-radius: 100px;
      -webkit-border-radius: 100px;
      -moz-border-radius:100px;
      box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.16);
      -webkit-box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.16);
       -moz-box-shadow:0px 3px 20px rgba(0, 0, 0, 0.16);
      // border: solid 1px $background_color_tooltip;
      &:after{
        content:"";
        position: absolute;
        transform-origin: center;
        transform:translate(-1px,-1px) scale(0);
        width: $button_size + 1;
        height: $button_size + 1;
        top:0;
        left: 0;
        border: 1px solid $background_color_tooltip;
        border-radius: 100px;
        -webkit-border-radius: 100px;
        -moz-border-radius:100px;
        -webkit-animation: pulsate 3s ease-out;
        -webkit-animation-iteration-count: infinite;
        animation: pulsate 3s ease-out;
        animation-iteration-count: infinite;
        @-webkit-keyframes pulsate {
          0% {
            transform: translate(-1px,-1px) scale(1, 1);
            opacity: 0;
          }
          15% {
            opacity: 1;
          }

          50%, 100% {
            transform: translate(-1px,-1px) scale(1.4, 1.4);
            opacity: 0.0;
          }

        }
        @keyframes pulsate {
          0% {
            transform: translate(-1px,-1px) scale(1, 1);
            opacity: 0;
          }
          15% {
            opacity: 1;
          }

          50%, 100% {
            transform: translate(-1px,-1px) scale(1.4, 1.4);
            opacity: 0.0;
          }
        }
      }

      .icon {
        width: 12px;
        height: 12px;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%,-50%,0) rotate(45deg);
        transition: transform 0.4s $cubic-ease-in-out;

        svg {
          display: block;
          overflow: visible;
          position: absolute;
          path {
            transition: 0.4s $cubic-ease-in-out;
            transition-property: stroke, transform;
            transform-origin: center center;
            stroke: #333;
            stroke-width: 2;
          }
        }

        .back {

          path {

            opacity: 1;
            transition: transform 0.4s $cubic-ease-in-out, opacity 0s;

            &:first-child {
              transform: translate3d(-2px, -4px, 0) rotate(-90deg) scaleX(0.75);
            }
            &:last-child {
              transform: translate3d(-2px, 4px, 0) rotate(90deg) scaleX(0.75);
            }

          }

        }
      }

      &.tooltip-button_close{
        .icon {
          transform: translate3d(-50%,-50%,0) rotate(0);
        }

        svg {
          path {
            stroke: $background_color_tooltip;
          }
        }

        .add-close {
          path {

            transition: 0.4s $cubic-ease-out, opacity 0s;

            &:first-child {
              transform: translate3d(0px, 0px, 0) rotate(0) scaleX(1);
              opacity: 1;
            }
            &:last-child {
              transform: translate3d(0px, 0px, 0) rotate(0) scaleX(1);
              opacity: 1;
            }

          }
        }

        .back_arrow-leave-active {
          transition: 0.4s $cubic-ease-in-out, opacity 0s 0.4s;
          + .add-close {

            path {

              transition: none;

              &:first-child {
                transform: translate3d(0px, 0px, 0) rotate(-45deg) scaleX(1);
                opacity: 0;
              }
              &:last-child {
                transform: translate3d(0px, 0px, 0) rotate(45deg) scaleX(1);
                opacity: 0;
              }
            }


          }
        }

        .back_arrow-leave-to {

          path {

            &:first-child {
              transform: translate3d(0px, 0px, 0) rotate(-45deg) scaleX(1);
              opacity: 1;
            }
            &:last-child {
              transform: translate3d(0px, 0px, 0) rotate(45deg) scaleX(1);
              opacity: 1;
            }

          }
        }

      }

      &.tooltip-button_back {

        svg {
          path {
            stroke: $background_color_tooltip;
          }
        }

        .icon {
          transform: translate3d(-50%,-50%,0) rotate(0);

          .add-close {
            opacity: 0;
            transition: opacity 0s 0.42s;
            path {
              &:first-child {
                transform: translate3d(0px, 0px, 0) rotate(-45deg) scaleX(1);
              }
              &:last-child {
                transform: translate3d(0px, 0px, 0) rotate(45deg) scaleX(1);
              }
            }
          }

          .back_arrow-enter-active {
            transition: 0.4s $cubic-ease-in-out;
          }
          .back_arrow-enter-active {
            transition-delay: 0.4s;
            path {
              transition-delay: 0.4s !important;
            }
          }

          .back_arrow-enter {
            path {

              &:first-child {
                transform: translate3d(0px, 0px, 0) rotate(-45deg) scaleX(1);
                opacity: 0;
              }
              &:last-child {
                transform: translate3d(0px, 0px, 0) rotate(45deg) scaleX(1);
                opacity: 0;
              }

            }
          }


        }

      }

      &.tooltip-button_close{
        background-color: $background_color_tooltip_menu;
        &:after{
          opacity: 0;
          visibility: hidden;
        }
      }
      &.tooltip-button_back{
        background-color: $background_color_tooltip_menu;
        &:after{
          opacity: 0;
          visibility: hidden;
        }
      }
    }
    .tooltip-info{
      position: absolute;
      top: $tooltip_height/2 - $button_size/2;
      right: $tooltip_width/2 + $button_size/2 + $padding;
      margin:auto;
      @include button-style-light;
      span{
        white-space: nowrap;
        svg{
          position: absolute;
          right: 20px;
          top: 24px;
        }
      }

      .tooltip-text {
        transform-origin: 90% 50%;
        &.tooltip_change-enter-active {
          transition: none;
        }

        span {
          display: flex;
          justify-content: flex-end;
        }
        strong {
          color: currentColor;
          transition: opacity 0.6s $cubic-ease-in-out;
          transition-delay: 0.2s;
        }

        span.loaded {
          transition: width 0.4s $cubic-ease-in-out;
        }

      }

      .tooltip-loading {
        transform-origin: right center;
        &.tooltip_change-leave-active {
          transition: none;
        }

        span {
          position: relative;
          color: transparent;
          padding-left: 1rem;
          padding-right: 1rem;
          svg {
            position: relative;
            height: 1.2rem;
            top: auto;
            right: auto;
            circle {
              fill: rgba(205, 205, 205, 1);
              animation: tooltip_loading 1s infinite;
              &:nth-child(2) {
                animation-delay: -150ms;
              }
              &:nth-child(1) {
                animation-delay: -300ms;
              }
            }
          }
        }
      }

      @keyframes tooltip_loading {
        0% {
          fill: rgba(205, 205, 205, 0.5);
        }
        40% {
          fill: rgba(205, 205, 205, 1);
        }
        80%, 100% {
          fill: rgba(205, 205, 205, 0.5);
        }
      }

    }

    .tooltip_change-enter-active, .tooltip_change-leave-active {
      position: absolute;
      right: 0;
      transition: 0.5s $cubic-ease-in-out;
    }

    .tooltip_change-leave, .tooltip_change-enter-to {
      transform: translate3d(0, 0, 0) scale(1);
      opacity: 1;
    }

    .tooltip_change-leave-to {
      transform: translate3d(0, -100%, 0) scale(1);
      opacity: 0;
    }

    .tooltip_change-enter {
      transform: translate3d(0, 100%, 0) scale(0);
      color: transparent;
      opacity: 0;
    }
  }
}
.menu-categories{
  @include cubic-transition(.6s);
  opacity: 0;

  .menu-categories-elem{
    transform:scale(0);
    -webkit-transform: scale(0);
  }
  height: 100%;
  &.visible{
    opacity: 1;
    visibility: visible;

    .menu-categories-elem{
      -webkit-animation: appear 0.7s $cubic-ease-in-out;
      animation:appear 0.7s $cubic-ease-in-out;
      animation-fill-mode: forwards;
      -webkit-animation-fill-mode: forwards;

    }
  }
  .menu-categories-elem{
    @include cubic-transition(.7s);
    text-align: center;
    @include button-style-light;
    margin: 0 $padding/2;
    cursor: pointer;
    opacity: 0;
  }
  .menu-categories-line{
    width: 100%;
    display: flex;
    justify-content: center;
    position: absolute;
  }
  .first_line{
    align-items: flex-end;
    top: $tooltip_height/2 - $button_size/2 - $button_size - $padding/2;
    .menu-categories-elem{
      &:nth-of-type(1){
        transform-origin: 100% 150%;
        -webkit-animation-delay:0ms;
        animation-delay:0ms;
        -moz-animation-delay: 0ms;
        -o-animation-delay:0ms;
      }
      &:nth-of-type(2){
        transform-origin: 0 150%;
        -webkit-animation-delay:$animation-delay*1;
        animation-delay:$animation-delay*1;
        -moz-animation-delay: $animation-delay*1;
        -o-animation-delay:$animation-delay*1;
      }

    }
  }
  .second_line{
    width: $tooltip_width/2 - $button_size;
    justify-content: flex-start;
    align-items: center;
    top: $tooltip_height/2 - $button_size/2;
    left: $tooltip_width/2 + $button_size/2 + $padding/2;
    .menu-categories-elem{
      &:nth-of-type(1){
        transform-origin: -50% 50%;
        -webkit-animation-delay:$animation-delay*2;
        animation-delay:$animation-delay*2;
        -moz-animation-delay:$animation-delay*2;
        -o-animation-delay:$animation-delay*2;
      }
    }
  }
  .third_line{
    align-items: flex-start;
    top: $tooltip_height/2 + $button_size/2 + $padding/2;
    .menu-categories-elem{
      &:nth-of-type(1){
        transform-origin: 75% -50%;
        -webkit-animation-delay:$animation-delay*4;
        animation-delay:$animation-delay*4;
        -moz-animation-delay: $animation-delay*4;
        -o-animation-delay:$animation-delay*4;
      }
      &:nth-of-type(2){
        transform-origin: -25% -50%;
        -webkit-animation-delay:$animation-delay*3;
        animation-delay:$animation-delay*3;
        -moz-animation-delay:$animation-delay*3;
        -o-animation-delay:$animation-delay*3;
      }
      //Only child
      &:first-of-type:last-of-type {
        transform-origin: 50% -50%;
      }
    }
  }
  &[data-count="6"] {
    .third_line{
      .menu-categories-elem{
        &:nth-of-type(1){
          transform-origin: 150% -50%;
          animation-delay:$animation-delay*6;
        }
        &:nth-of-type(2){
          transform-origin: 50% -50%;
          animation-delay:$animation-delay*5;
        }
        &:nth-of-type(3){
          transform-origin: -50% -50%;
          animation-delay:$animation-delay*4;
        }
      }
    }
  }

}
.menu-furnitures{
  @include cubic-transition(.6s);
  opacity: 0;
  transform:scale(0);
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &.item-selected{
    .menu-furnitures-elem{
      opacity: $opacity_furniture_not_selected;
    }
  }
  &.visible{
    opacity: 1;
    transform:scale(1);
    visibility: visible;
    .menu-furnitures-elem{
      .furniture-background{
        -webkit-animation: appear 0.7s ease-out;
        animation:appear 0.7s ease-out;
        animation-fill-mode: forwards;
        -webkit-animation-fill-mode: forwards;

      }
    }
  }
  .menu-furnitures-elem{
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    position: absolute;
    cursor: pointer;
    width: 80px;
    height: 80px;
    &.ui-draggable-dragging{

    }
    &.selected{
      opacity: 1 !important;
      .furniture-background{
        -webkit-animation-delay:0ms !important;
        animation-delay:0ms !important;
        -moz-animation-delay::0ms !important;
        -o-animation-delay:0ms !important;
        -webkit-animation: appear .2s ease-out !important;
        animation:appear .2s ease-out !important;
        animation-fill-mode: forwards !important;
        -webkit-animation-fill-mode: forwards !important;
      }
    }
    &:nth-of-type(1){
      bottom: 162px;
      right: 350px;
      .furniture-background{
        -webkit-animation-delay:100ms;
        animation-delay:100ms;
        -moz-animation-delay: 100ms;
        -o-animation-delay:100ms;
      }
    }
    &:nth-of-type(2){
      bottom: 181px;
      left: 290px;
      .furniture-background{
        -webkit-animation-delay:200ms;
        animation-delay:200ms;
        -moz-animation-delay: 200ms;
        -o-animation-delay:200ms;
      }
    }
    &:nth-of-type(3){
      top: 64px;
      left: 370px;
      .furniture-background{
        -webkit-animation-delay:300ms;
        animation-delay:300ms;
        -moz-animation-delay: 300ms;
        -o-animation-delay:300ms;
      }
    }
    &:nth-of-type(4){
      top: 154px;
      left: 359px;
      .furniture-background{
        -webkit-animation-delay:400ms;
        animation-delay:400ms;
        -moz-animation-delay: 400ms;
        -o-animation-delay:400ms;
      }
    }
    &:nth-of-type(5){
      top: 190px;
      left: 283px;
      .furniture-background{
        -webkit-animation-delay:500ms;
        animation-delay:500ms;
        -moz-animation-delay: 500ms;
        -o-animation-delay:500ms;
      }
    }
    &:nth-of-type(6){
      top: 168px;
      left: 209px;
      .furniture-background{
        -webkit-animation-delay:600ms;
        animation-delay:600ms;
        -moz-animation-delay: 600ms;
        -o-animation-delay:600ms;
      }
    }
    &:nth-of-type(7){
      top: 10px;
      left: 460px;
      .furniture-background{
        -webkit-animation-delay:800ms;
        animation-delay:800ms;
        -moz-animation-delay: 800ms;
        -o-animation-delay:800ms;
      }
    }
    &:nth-of-type(8){
      top: 120px;
      left: 460px;
      .furniture-background{
        -webkit-animation-delay:800ms;
        animation-delay:800ms;
        -moz-animation-delay: 800ms;
        -o-animation-delay:800ms;
      }
    }
    &:nth-of-type(9){
      top: -30px;
      left: 370px;
      .furniture-background{
        -webkit-animation-delay:800ms;
        animation-delay:800ms;
        -moz-animation-delay: 800ms;
        -o-animation-delay:800ms;
      }
    }
    .furniture-background{
      opacity: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      pointer-events: none;
      img{
        max-width: 100%;
        max-height: 100%;
      }
    }
  }

}

.ui-widget-draggable{
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  position: absolute;
  cursor: pointer;
  &.ui-state-dropped{
    background: transparent;
    .revert{
      width: 80px;
      height: 80px;
      opacity:1;
    }
  }
}


.ui-widget-droppable{
  position: absolute;
  z-index: 20;
  width: 0px;
  height: 0px;
  opacity: 0;
  visibility: hidden;
  border:solid 2px rgba(255, 0, 0, 0.8);
  border-radius: 200px;
  -webkit-border-radius: 200px;
  -moz-border-radius: 200px;
  @include cubic-transition(.6s);
  &:nth-of-type(9){
    width: 0px;
    height: 0px;
    transform-origin: center;
    transform: translate(-40px,0px);
    &.visible{
      width: 250px;
      height: 140px;
      transform: translate(-30px,10px);
    }
  }
  &.visible{
    visibility: visible;
    opacity: 0;
    width: 120px;
    height: 120px;
  }
}
@media only screen and (max-width: 930px)  {
  .ui-widget-droppable{
    &.visible{
      visibility: visible;
      opacity: 0;
      transform: translate(0,25px);
      width: 90px;
      height:90px;
    }
  }
}
@media only screen and (min-width: 1600px)  {
  .ui-widget-droppable{
    &.visible{
      width: 150px;
    }
  }
}

.controls-furniture{
  position: absolute;
  top: 0;
  z-index: 333;
  opacity: 0;
  visibility: hidden;
  &.visible{
    opacity: 1;
    visibility: visible;
    .rotate{
      transform:translate(-48px,14px)  scale(1);
      -webkit-transform: translate(-48px,14px)  scale(1);
    }
    .delete{
      transform: scale(1);
      -webkit-transform: scale(1);
    }
  }
  .rotate{
    cursor: pointer;
    @include cubic-transition(.4s);
    transform-origin: center;
    -webkit-transform-origin: center;
    width: 50px;
    height: 50px;
    background: #fff;
    border-radius: 100px;
    -webkit-border-radius: 100px;
    -moz-border-radius:100px;
    position: relative;
    transform:translate(-48px,10px)  scale(0);
    -webkit-transform:translate(-48px,10px)  scale(0);
    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.16);
    -webkit-box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.16);
     -moz-box-shadow:0px 3px 20px rgba(0, 0, 0, 0.16);
    svg{
      position: absolute;
      top:0;
      left:0;
      bottom:0;
      right:0;
      margin: auto;
    }
  }
  .delete{
    cursor: pointer;
    @include cubic-transition(.4s);
    width: 50px;
    height: 50px;
    background: #fff;
    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.16);
    -webkit-box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.16);
     -moz-box-shadow:0px 3px 20px rgba(0, 0, 0, 0.16);
    border-radius: 100px;
    -webkit-border-radius: 100px;
    -moz-border-radius:100px;
    position: relative;
    transform: scale(0);
    -webkit-transform: scale(0);
    transform-origin: center;
    -webkit-transform-origin: center;
    svg{
      position: absolute;
      top:0;
      left:0;
      bottom:0;
      right:0;
      margin: auto;
    }
  }
}

.configurator_controls{
  z-index: 200;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
}

@-webkit-keyframes appear{
  from{
    opacity: 0;
    transform: scale(0.25);
  }
  to{
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes appear{
  from{
    opacity: 0;
    transform: scale(0.25);
  }
  to{
    opacity: 1;
    transform: scale(1);
  }
}
.no-touchevents{
  .tooltip-button{
    .icon{
      @include cubic-transition(.4s);
      transform: translate3d(-50%, -50%, 0) rotate(45deg) scale(1);
    }
    &:hover{
      .icon{
        transform: translate3d(-50%, -50%, 0) rotate(45deg) scale(.9);
      }
    }
  }
}


</style>
